import e from "@emotion/css/create-instance";
import r from "@emotion/server/create-instance";
var t = e({
  key: "leafygreen-ui",
  prepend: !0
}),
    a = t.flush,
    s = t.hydrate,
    o = t.cx,
    c = t.merge,
    i = t.getRegisteredStyles,
    n = t.injectGlobal,
    l = t.keyframes,
    m = t.css,
    d = t.sheet,
    y = t.cache,
    f = r(y),
    g = f.extractCritical,
    p = f.renderStylesToString,
    S = f.renderStylesToNodeStream;
export { y as cache, m as css, o as cx, t as default, g as extractCritical, a as flush, i as getRegisteredStyles, s as hydrate, n as injectGlobal, l as keyframes, c as merge, S as renderStylesToNodeStream, p as renderStylesToString, d as sheet };